import React, {useState} from "react";
import {deleteItem, saveData} from "../../../helpers/Api";
import {Button, Col, Row} from "react-bootstrap";
import FlashMessage from "../../shared/FlashMessage";
import ListTable from "../../shared/ListTable";
import {DeleteButton} from "../../../helpers/ButtonHelper";
import {useMutation, useQuery} from "@apollo/client";
import {createMedicationMutation, deleteMedicationMutation, getMedicationsQuery} from "./MediactionQueries";

const MedicationList = ({user}) => {
  const {data, loading, refetch} = useQuery(getMedicationsQuery, {variables: {clientId: user.id}})
  const [flash, setFlash] = useState({});
  const [deleteCall] = useMutation(deleteMedicationMutation, {refetchQueries: refetch})
  const [saveCall] = useMutation(createMedicationMutation)

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: 'createMedication',
      flash_callback: setFlash,
      success: (res) => {
        refetch()
        event.target.reset()
      }
    })
  }

  const header = <tr>
    <th>Medicament</th>
    <th>Dozaj zilnic</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>{item.name}</td>
      <td>{item.dosage}</td>
      <td className='actions'>
        <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall)}/>
      </td>
    </tr>
  }

  return (
    <div className="container">
      <form onSubmit={onSubmit}>
        <Row className="mb-2">
          <Col>
            <FlashMessage flash={flash}/>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm>
            <label htmlFor="name">Medicament:</label>
            <input type='hidden' name='clientId' className="form-control" id="clientId" value={user.id}/>
            <input type='text' name='name' className="form-control" id="name" placeholder="Algocalmin 50mg"/>
          </Col>
          <Col>
            <label htmlFor="dosage">Dozaj zilnic:</label>
            <input type='text' name='dosage' className="form-control" id="dosage" placeholder="1 - 0 - 1"/>
          </Col>
          <Col className="col-auto">
            <br/>
            <Button type='submit'>Adauga</Button>
          </Col>
        </Row>
      </form>
      <hr/>

      {!loading &&
        <ListTable data={data.medications} header={header} listItem={listItem} showSearch={false}/>
      }
    </div>
  );
}

export default MedicationList